export default __webpack_public_path__ + "static/article-why-a-personal-loan-is-the-best-way-to-buy-your-dream-car-2e7a78b834df20763c5a3b2ad7d83013.jpg";